<div class="card-container-container">
  <div class="card-container">
    <mat-card>
      <mat-card-content>
        <div class="fx-fill fx-layout-col fx-justify-start fx-align-stretch">
          @if (!!globalBIReport) {
            <power-bi-report class="fx-fill"
                             [currentReport]="globalBIReport"
                             [relatedEntityType]="EntityType.ORGANIZATION">
            </power-bi-report>
          } @else {
            <div class="empty-section fx-fill fx-layout-col fx-justify-center fx-align-center">
              <h4 id="no_global_report_label">
                {{ "LABEL.NO_GLOBAL_REPORT" | translate }}
              </h4>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
